// Moment and locales must be imported this way to avoid bundling every single locale in the app
import moment from '../../../common/moment-timezone/moment-timezone';
// These have ".." in the middle as moment has been aliased to moment/src/moment.
import 'moment/../locale/fi';
import 'moment/../locale/sv'; // <-- This is Swedish, 'se' is Northern Sami
import 'moment/../locale/en-gb'; // <-- Different from default US locale

import {parseLanguage} from '../language.utils';

/**
 * Default timezone of the system.
 *
 * NOTE: This MUST be included in the timezone database if a custom db is used!
 *
 * @type {string}
 */
const DEFAULT_TZ = 'Europe/Helsinki';

/**
 * Configure moment-timezone to use the correct timezones and custom localization.
 */
function configMoment() {
  moment.tz.setDefault(DEFAULT_TZ);

  // Overwrite calendar strings (defaults to lowercase tänään, huomenna..)
  moment.updateLocale('fi', {
    calendar: {
      sameDay: '[Tänään] [klo][\xa0]LT',
      nextDay: '[Huomenna] [klo][\xa0]LT',
      nextWeek: 'dddd [klo][\xa0]LT',
      sameElse: 'L'
    }
  });

  // Overwrite default implementation by adding [kl] to all strings
  moment.updateLocale('sv', {
    calendar: {
      sameDay: '[I dag] [kl][\xa0]LT',
      nextDay: '[I morgon] [kl][\xa0]LT',
      nextWeek: 'dddd [kl][\xa0]LT'
    }
  });

  moment.updateLocale('en', {
    calendar: {
      sameDay: '[Today] [at][\xa0]LT',
      nextDay: '[Tomorrow] [at][\xa0]LT',
      nextWeek: 'dddd [at][\xa0]LT'
    }
  });

  // Overwrite default localtime for english to use 24 hour clock instead of 12 hour clock
  // Also use Finnish presentation for LT and L
  // We need to copy all values, there is no way to set just one
  moment.updateLocale('en', {
    longDateFormat: {
      LT: "HH.mm",
      L: "DD.MM.YYYY",
      LL: "MMMM D YYYY",
      LLL: "MMMM D YYYY LT",
      LLLL: "dddd, MMMM D YYYY LT"
    },

    // Overwrite default moment day abbreviations for English to use three letter names instead of
    // two letter names
    weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  });

  // Use Finnish presentation for LT and L
  // We need to copy all values, there is no way to set just one
  moment.updateLocale('sv', {
    longDateFormat: {
      LT: "HH.mm",
      L: "DD.MM.YYYY",
      // Source for rest: https://github.com/moment/moment/blob/2.24.0/locale/sv.js
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY LT',
      LLLL: 'dddd D MMMM YYYY LT',
    }
  });

  moment.locale(parseLanguage());
}

export { DEFAULT_TZ };
export default configMoment;
